import Vue from 'vue'
import Vuex from 'vuex'
import ls from 'local-storage'
import jwt from 'jwt-decode'

Vue.use(Vuex)

const t = ls('token');

const state = {
  isLogged: !!ls('token'),
  isAdmin: t ? jwt(t).role === 'admin' ? true : false : false,
}

const mutations = {
  LOGIN_USER(state) {
    state.isLogged = true
  },

  LOGOUT_USER(state) {
    state.isLogged = false
  },
  IS_ADMIN(state) {
    console.log()
    state.isAdmin = jwt(ls('token')).role === 'admin' ? true : false
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js